import { createContext } from 'react'
import { ChartContextType } from './chartWrapper'
import { ChartDataContextType } from './chart.typings'


const ChartContext = createContext<ChartContextType | null>(null)

const ChartDataContext = createContext<ChartDataContextType>({
    getData: () => {
        return {}
    }
})

export {
    ChartContext,
    ChartDataContext
}